import React, {useCallback, useContext} from "react"
import NewNote from '../../../Notes/ObjectNotes/NewObjectNote'
import NoteList from '../../../Notes/ObjectNotes/ObjectNotesList'
import { GET_LISTING_NOTES, CREATE_NOTE, LISTING_UPDATE_NOTE } from './Queries'
import { DispatchContext } from "../../../store"
import { isNullArray } from "../../../common/helpers"
import { severity } from "../../../Snackbar/CustomizedSnackbar"
import { withApollo } from "@apollo/client/react/hoc"

function ListingNotes(props) {

	const [notes, setNotes] = React.useState([])
	const [notesLoading, setNotesLoading] = React.useState(true)

	//Snackbar
	const dispatch = useContext(DispatchContext)
	const openSnackbar = useCallback((severity, text) => {
		dispatch({ type: 'openSnackBar', payload: { severity, text }})
	}, [dispatch])

	// Modal
	const [editNoteModal, setEditNoteModal] = React.useState({open: false, note: null})

	React.useEffect(() => {

		let active = true

		if (!props.findMode && props.id > 0) {
			setNotesLoading(true)
			setNotes([])
			
			props.client
				.query({ query: GET_LISTING_NOTES, variables: { listing_id: props.id}})
				.then(notesData => {
					if (active) {
						setNotesLoading(false)
						if (notesData?.data && !isNullArray(notesData?.data?.getListingNotes)) {
							setNotes(notesData?.data.getListingNotes || [])
						} else if (isNullArray(notesData?.data?.getListingNotes)) {
							setNotes([])
							openSnackbar(severity.ERROR, "Error - Unauthorized")
						}
					}
				})
		}

		return () => active = false

	}, [openSnackbar, props.client, props.findMode, props.id])
	
	return (!props.findMode && props.id > 0) && (
		<section className="main-page">
			<div>
				<NewNote
					entityId={props.id}
					notes={notes}
					setNotes={setNotes}
					notesLoading={notesLoading}
					mutation={CREATE_NOTE}
					mutationName="createListingNote"
					linkField="listing_id"
					state={props.state}
					setState={props.setState}
					criticalNotes="getCriticalListingNotes"
					privateEntity={false}
				/>
				<NoteList
					editNoteModal={editNoteModal}
					setEditNoteModal={setEditNoteModal}
					state={props.state}
					setState={props.setState}
					notes={notes}
					setNotes={setNotes}
					notesLoading={notesLoading}
					mutationResponse="updateListingNote"
					updateMutationName={LISTING_UPDATE_NOTE}
					criticalNotes="getCriticalListingNotes"
					linkField="listing_id"
					privateEntity={props.state?.getDeal?.is_private || false}
				/>
				
			</div>
		</section>
	)
}

export default withApollo(ListingNotes)
